import styled from 'styled-components';

export const ClockStyled = styled.div`
  position: absolute;
  bottom: 5%;
  right: 5%;
  font-weight: bold;
  z-index: 10;

  span {
    text-align: left;
    font: normal normal bold 11.428rem/13.714rem Roboto, Heebo;
    letter-spacing: 0px;
    color: #ffffff;
    text-shadow: 3px 3px 10px #00000082;
    opacity: 1;
  }
`;
